//#region src/modules/CountryRegion.ts
var e = [{
	country: "supporter.country",
	region: "supporter.region",
	postcode: "supporter.postcode"
}, {
	country: "transaction.infcountry",
	region: "transaction.infreg",
	postcode: "transaction.infpostcd"
}], t = {
	US: "State",
	CA: "Province",
	GB: "County"
}, n = {
	US: "Zip Code",
	CA: "Postal Code",
	GB: "Postcode"
}, r = class {
	groups;
	regionLabels;
	defaultRegionLabel;
	postcodeLabels;
	defaultPostcodeLabel;
	constructor(r = {}) {
		this.groups = r.groups ?? e, this.regionLabels = r.regionLabels ?? t, this.defaultRegionLabel = r.defaultRegionLabel ?? "Region", this.postcodeLabels = r.postcodeLabels ?? n, this.defaultPostcodeLabel = r.defaultPostcodeLabel ?? "Postal Code", this.init();
	}
	init() {
		this.groups.forEach((e) => this.bindGroup(e));
	}
	bindGroup(e) {
		let t = document.querySelector(`select[name="${e.country}"]`);
		if (!t) return;
		let n = this.findLabel(e.region), r = this.findLabel(e.postcode);
		if (!n && !r) return;
		let i = () => {
			let e = t.value;
			n && (n.textContent = this.regionLabels[e] ?? this.defaultRegionLabel), r && (r.textContent = this.postcodeLabels[e] ?? this.defaultPostcodeLabel);
		};
		t.addEventListener("change", i), i();
	}
	findLabel(e) {
		let t = document.querySelector(`[name="${e}"]`);
		if (!t) return null;
		if (t.id) {
			let e = document.querySelector(`label[for="${t.id}"]`);
			if (e) return e;
		}
		return t.closest(".en__field")?.querySelector("label.en__field__label:not(.en__field__label--item)") ?? null;
	}
}, i = class {
	element;
	startOpen;
	isShown;
	constructor(e, t = !1) {
		this.element = e, this.startOpen = t, this.isShown = !1, this.element || console.warn("Collapse element not found"), this.element.classList.add("collapse"), this.startOpen ? this.show() : this.hide();
	}
	show() {
		this.element.removeAttribute("inert"), this.element.removeAttribute("aria-hidden"), this.element.classList.add("show"), this.isShown = !0;
	}
	hide() {
		this.element.setAttribute("inert", ""), this.element.setAttribute("aria-hidden", "true"), this.element.classList.remove("show"), this.isShown = !1;
	}
	toggle() {
		this.isShown ? this.hide() : this.show();
	}
}, a = () => {
	document.querySelectorAll("link[rel=\"stylesheet\"]").forEach((e) => {
		e.href.includes("/pageassets/css/enPage.css") && e.parentNode?.removeChild(e);
	});
}, o = {
	enabled() {
		try {
			return window.ZURI_EN_DEBUG === !0 ? !0 : new URLSearchParams(window.location.search).get("zuri-debug") === "1";
		} catch {
			return !1;
		}
	},
	log(...e) {
		this.enabled() && console.log("[zuri-en]", ...e);
	},
	info(...e) {
		this.enabled() && console.info("[zuri-en]", ...e);
	},
	warn(...e) {
		this.enabled() && console.warn("[zuri-en]", ...e);
	}
}, s = class {
	_config;
	eCardPicker;
	tributeOptions;
	defaultTributeType;
	eCardCollapse = null;
	constructor(e) {
		o.log("Initializing ECardPicker with config:", e), this._config = e, this.eCardPicker = document.querySelector("#ecard-picker"), this.eCardPicker && (this.tributeOptions = document.querySelectorAll(".en__field--trbopts .en__field__input"), this.defaultTributeType = document.querySelector(".en__field--trbopts .en__field__input--radio:checked"), this.init());
	}
	async init() {
		this.#e(), this.#t(), this.#n(), this.#r();
		let e = await this.#i();
		this.#a(e);
	}
	#e() {
		let e = this._config.deliveryOptionsSelector;
		console.log("Delivery options selector:", e);
		let t = document.querySelector(e), n = this.eCardPicker?.closest(".en__component--codeblock");
		this.eCardCollapse = n ? new i(n) : null;
		let r = t?.querySelectorAll(".en__field__input--checkbox, .en__field__input--radio");
		r?.forEach((e) => {
			e?.addEventListener("click", (e) => {
				let t = e.target;
				t.value === "ecard" && t.checked && this.eCardCollapse ? (this.eCardPicker.querySelector("input").checked = !0, this.eCardCollapse.show()) : this.eCardCollapse && this.eCardCollapse.hide();
			});
		}), r?.forEach((e) => {
			new MutationObserver((e) => {
				e.forEach((e) => {
					let t = e.target;
					t.value === "ecard" && !t.checked && this.eCardCollapse?.hide();
				});
			}).observe(e, { attributes: !0 });
		});
	}
	#t() {
		let e = document.getElementById("en__field_transaction_inmem");
		e?.addEventListener("click", () => {
			sessionStorage.setItem("en__field_transaction_inmem", e.checked ? "true" : "false"), e.checked || this.eCardCollapse?.hide();
		});
	}
	#n() {
		let e = document.querySelector(this._config.deliveryOptionsSelector), t = document.getElementById("en__field_transaction_inmem");
		!e || !t || e.addEventListener("change", () => {
			let t = e.querySelector(".en__field__input--radio:checked")?.value;
			sessionStorage.setItem("notificationType", {
				ecard: "ecard",
				letter: "letter",
				mailed: "mailed",
				N: "do-not-notify"
			}[t] || "NA");
		});
	}
	#r() {
		let e = () => {
			let e = document.getElementById("en__field_transaction_infname"), t = document.getElementById("en__field_transaction_infemail"), n = document.getElementById("en__field_transaction_gftrsn"), r = {
				name: e?.value || "",
				email: t?.value || "",
				message: n?.value || ""
			};
			sessionStorage.setItem("recipient", JSON.stringify(r));
		}, t = document.getElementById("en__field_transaction_infname"), n = document.getElementById("en__field_transaction_infemail"), r = document.getElementById("en__field_transaction_gftrsn");
		t?.addEventListener("change", (t) => {
			t.target.value && e();
		}), n?.addEventListener("change", (t) => {
			t.target.value && e();
		}), r?.addEventListener("change", (t) => {
			t.target.value && e();
		});
	}
	async #i() {
		try {
			let e = window.eCardPageID || null;
			if (!e) return console.warn("could not initialize eCard picker, window.eCardPageID not found"), [];
			let t = new URL(`/page/${e}/action/1`, window.location.origin), n = new URLSearchParams(window.location.search);
			[
				"ea.tracking.id",
				"ea.url.id",
				"utm_medium",
				"utm_source",
				"utm_campaign",
				"utm_content"
			].forEach((e) => {
				let r = n.get(e);
				r && t.searchParams.set(e, r);
			});
			let r = await fetch(t.toString());
			if (!r.ok) throw Error(`HTTP error! Status: ${r.status}`);
			let i = await r.text();
			i = i.replace(/<script\b[^>]*>([\s\S]*?)<\/script>/gim, "");
			let a = new DOMParser().parseFromString(i, "text/html").querySelector(".en__ecarditems__list");
			if (!a) return console.warn("Container not found"), [];
			let o = a.querySelectorAll(".en__ecarditems__thumb");
			return Array.from(o).map((e) => ({
				id: e.getAttribute("data-id"),
				imgSrc: e.querySelector("img")?.getAttribute("src") ?? null
			}));
		} catch (e) {
			return console.error("Error:", e), [];
		}
	}
	#a(e) {
		this.eCardPicker.classList.add("ecard-picker"), e.forEach((t, n) => {
			let r = `ecard-radio-${t.id || n}`, i = document.createElement("label");
			i.classList.add("ecard-item"), i.setAttribute("tabindex", "0"), i.setAttribute("for", r), i.setAttribute("aria-label", `Select eCard ${t.id}`), i.setAttribute("role", "radio"), i.setAttribute("aria-checked", "false");
			let a = document.createElement("input");
			a.type = "radio", a.name = "ecard", a.value = t.id || "", a.id = r, a.classList.add("ecard-radio"), a.hidden = !0;
			let o = document.createElement("span");
			o.className = "ecard-item-img", o.style.display = "block", o.style.position = "relative";
			let s = document.createElement("img");
			s.src = t.imgSrc || "", s.alt = `eCard ${t.id}`, o.appendChild(s), a.addEventListener("change", () => {
				a.checked && (sessionStorage.setItem("selectedECard", t.id || ""), this.eCardPicker.querySelectorAll(".ecard-item").forEach((e) => {
					e.setAttribute("aria-checked", "false");
				}), i.setAttribute("aria-checked", "true"));
			}), i.appendChild(a), i.appendChild(o), i.addEventListener("keydown", (t) => {
				t.key === " " || t.key === "Enter" ? (t.preventDefault(), a.checked = !0, a.dispatchEvent(new Event("change", { bubbles: !0 }))) : t.key === "ArrowRight" || t.key === "ArrowDown" ? (t.preventDefault(), this.#o(n, e.length)) : (t.key === "ArrowLeft" || t.key === "ArrowUp") && (t.preventDefault(), this.#s(n, e.length));
			}), i.addEventListener("focus", () => {
				i.style.outline = "2px solid var(--zg-color-primary)", i.style.outlineOffset = "2px";
			}), i.addEventListener("blur", () => {
				i.style.outline = "none";
			}), this.eCardPicker.appendChild(i);
		});
		let t = this.eCardPicker.querySelector(".ecard-radio");
		t && (t.checked = !0, t.dispatchEvent(new Event("change", { bubbles: !0 })));
	}
	#o(e, t) {
		let n = (e + 1) % t;
		this.eCardPicker.children[n]?.focus();
	}
	#s(e, t) {
		let n = (e - 1 + t) % t;
		this.eCardPicker.children[n]?.focus();
	}
}, c = class {
	nameInput;
	emailInput;
	messageInput;
	constructor() {
		this.nameInput = document.querySelector(".en__ecardrecipients__name input"), this.emailInput = document.querySelector(".en__ecardrecipients__email input"), this.messageInput = document.querySelector("textarea.en__ecardmessage__default"), this.init();
	}
	init() {
		o.log("Initializing ECardSender"), !(!this.nameInput || !this.emailInput || !this.messageInput) && (o.log("ECardSender inputs found, setting up submit handler"), this.#e());
	}
	#e() {
		if (sessionStorage.getItem("notificationType") !== "ecard") return;
		let e = sessionStorage.getItem("recipient"), t = sessionStorage.getItem("selectedECard");
		if (e && t) {
			let n = JSON.parse(e), r = n.name, i = n.email, a = n.message;
			this.nameInput.value = r, this.emailInput.value = i, this.messageInput.value = a, setTimeout(() => {
				document.querySelector(".en__ecarditems__button.en__ecarditems__addrecipient")?.click(), document.querySelector(`[data-id="${t}"]`)?.click();
			}, 1e3), sessionStorage.removeItem("notificationType"), sessionStorage.removeItem("recipient"), sessionStorage.removeItem("selectedECard");
			let o = 2, s = setInterval(function() {
				o <= 0 && (clearInterval(s), document.querySelector(".en__component--page")?.submit()), --o;
			}, 1200);
		}
	}
}, l = class {
	constructor() {
		this.init();
	}
	init() {
		let e = document.querySelector("input[name=\"transaction.paycurrency\"].en__field__input--hidden");
		e && this.setupHiddenInput(e);
		let t = document.querySelector(".en__field--paycurrency:has(.en__field__input--select)");
		t && this.setupSelect(t);
		let n = document.querySelector(".en__field--paycurrency:has(.en__field__input--radio)");
		n && this.setupRadio(n);
	}
	updateCurrency(e) {
		o.log("Currency updated to:", e);
		let t = Array.from(document.body.classList).filter((e) => e.startsWith("currency-"));
		document.body.classList.remove(...t), document.body.classList.add(`currency-${e.toLowerCase()}`);
	}
	setupHiddenInput(e) {
		let t = e.value || "USD";
		this.updateCurrency(t);
	}
	setupSelect(e) {
		let t = e.querySelector(".en__field__input--select");
		t && (t.addEventListener("change", (e) => {
			let t = e.target;
			this.updateCurrency(t.value);
		}), this.updateCurrency(t.value));
	}
	setupRadio(e) {
		e.querySelectorAll(".en__field__input--radio").forEach((e) => {
			e.addEventListener("change", (e) => {
				let t = e.target;
				t.checked && this.updateCurrency(t.value);
			}), e.checked && this.updateCurrency(e.value);
		});
	}
};
function u() {
	new l();
}
//#endregion
//#region src/utils/InputMask.ts
var d = class {
	input;
	type;
	constructor(e, t) {
		this.input = e, this.type = t, this.init();
	}
	init() {
		this.setInputMode(), this.input.addEventListener("beforeinput", this.handleBeforeInput), this.input.addEventListener("input", this.handleInput), this.input.addEventListener("paste", this.handlePaste);
	}
	setInputMode() {
		switch (this.type) {
			case "currency":
				this.input.inputMode = "decimal";
				break;
			case "bankAccount":
			case "routingNumber":
				this.input.inputMode = "numeric";
				break;
		}
	}
	handleBeforeInput = (e) => {
		if (e.data) switch (this.type) {
			case "currency":
				this.validateCurrencyInput(e);
				break;
			case "bankAccount":
			case "routingNumber":
				this.validateNumericInput(e);
				break;
		}
	};
	validateCurrencyInput(e) {
		let t = e.data, n = this.input.value, r = this.input.selectionStart ?? n.length;
		if (!/^[\d.]$/.test(t)) {
			e.preventDefault();
			return;
		}
		if (t === "." && n.includes(".")) {
			e.preventDefault();
			return;
		}
		let i = n.indexOf(".");
		if (i !== -1) {
			let a = n.slice(i + 1);
			r > i && a.length >= 2 && t !== "." && e.preventDefault();
		}
	}
	validateNumericInput(e) {
		/^\d$/.test(e.data) || e.preventDefault();
	}
	handleInput = () => {
		switch (this.type) {
			case "routingNumber":
				this.input.value.length > 9 && (this.input.value = this.input.value.slice(0, 9));
				break;
			case "bankAccount":
				this.input.value.length > 17 && (this.input.value = this.input.value.slice(0, 17));
				break;
			case "currency":
				this.input.value.length > 1 && this.input.value.startsWith("0") && this.input.value[1] !== "." && (this.input.value = this.input.value.replace(/^0+/, ""));
				break;
		}
	};
	handlePaste = (e) => {
		e.preventDefault();
		let t = e.clipboardData?.getData("text") ?? "", n = "";
		switch (this.type) {
			case "currency":
				n = t.replace(/[^\d.]/g, "");
				let e = n.split(".");
				e.length > 2 && (n = e[0] + "." + e.slice(1).join(""));
				let [r, i] = n.split(".");
				n = i === void 0 ? r : `${r}.${i.slice(0, 2)}`;
				break;
			case "routingNumber":
				n = t.replace(/\D/g, "").slice(0, 9);
				break;
			case "bankAccount":
				n = t.replace(/\D/g, "").slice(0, 17);
				break;
		}
		let r = this.input.selectionStart ?? 0, i = this.input.selectionEnd ?? 0, a = this.input.value;
		this.input.value = a.slice(0, r) + n + a.slice(i);
		let o = r + n.length;
		this.input.setSelectionRange(o, o), this.input.dispatchEvent(new Event("input", { bubbles: !0 }));
	};
	destroy() {
		this.input.removeEventListener("beforeinput", this.handleBeforeInput), this.input.removeEventListener("input", this.handleInput), this.input.removeEventListener("paste", this.handlePaste);
	}
}, f = (e) => new d(e, "currency"), p = (e) => new d(e, "bankAccount"), m = (e) => new d(e, "routingNumber"), h = class {
	element = null;
	config = null;
	constructor(e) {
		this.config = e ?? null, this.init();
	}
	init() {
		this.element = document.querySelector(".en__field--donationAmt"), this.element && (this.config && (this.setSuffixTokens(this.config), this.addPlaceholder()), this.applyOtherAmountStyle(), this.addInputMask(), this.setupRawAmountInput(), this.disableAutoComplete(), this.handleOtherAmountClick());
	}
	setSuffixTokens(e) {
		if (!this.element) return;
		let { suffix: t } = e;
		t.ONE_TIME && this.element.style.setProperty("--suffix-one-time", `"${t.ONE_TIME}"`), t.MONTHLY && this.element.style.setProperty("--suffix-monthly", `"${t.MONTHLY}"`), t.QUARTERLY && this.element.style.setProperty("--suffix-quarterly", `"${t.QUARTERLY}"`), t.ANNUAL && this.element.style.setProperty("--suffix-annual", `"${t.ANNUAL}"`);
	}
	addInputMask() {
		let e = this.element?.querySelector(".en__field__input--other");
		e && f(e);
	}
	setupRawAmountInput() {
		if (!this.element) return;
		let e = this.element.querySelector(".en__field__element--number");
		if (!e) return;
		let t = e.querySelector(".en__field__input--number");
		t && (t.type = "text", t.autocomplete = "off", f(t));
	}
	addPlaceholder() {
		if (!this.element || !this.config?.otherAmountPlaceholder) return;
		let e = this.element.querySelector(".en__field__input--other");
		e && (e.placeholder = this.config.otherAmountPlaceholder || "Other");
	}
	applyOtherAmountStyle() {
		this.element && this.element.classList.toggle("other-amount--button", this.config?.otherAmountStyle === "button");
	}
	disableAutoComplete() {
		let e = this.element?.querySelector(".en__field__input--other");
		e && (e.autocomplete = "off");
	}
	handleOtherAmountClick() {
		let e = this.element?.querySelector(".en__field--donationAmt .en__field__item--other"), t = this.element?.querySelector(".en__field--donationAmt .en__field__input--other");
		e && t && e.addEventListener("click", (e) => {
			e.target !== t && t.focus();
		});
	}
}, g = [
	"one-time",
	"monthly",
	"quarterly",
	"annual",
	"recurring"
], _ = ".en__component--page", v = "transaction.recurrfreq", y = class {
	frequencyEl;
	hiddenEl = null;
	lastEmitted = null;
	rescheduleScheduled = !1;
	constructor() {
		this.frequencyEl = document.querySelector(".en__field--recurrfreq"), this.frequencyEl || (this.hiddenEl = document.querySelector(`input[type="hidden"][name="${v}"]`)), this.init();
	}
	init = () => {
		this.frequencyEl ? this.addGlobalClass() : this.hiddenEl && this.setupHidden();
	};
	getCheckedFrequency() {
		return this.hiddenEl ? this.hiddenEl.value || null : this.frequencyEl?.querySelector("input[type=\"radio\"]:checked")?.value ?? null;
	}
	updateClasses(e) {
		document.body.classList.remove(...g);
		let t = e.toLowerCase().replace("_", "-");
		document.body.classList.add(t), e !== "ONE_TIME" && document.body.classList.add("recurring");
	}
	emit(e) {
		e !== this.lastEmitted && (this.lastEmitted = e, this.updateClasses(e), document.body.dispatchEvent(new CustomEvent("frequency-change", { detail: { frequency: e } })));
	}
	scheduleReEvaluate = () => {
		this.rescheduleScheduled || (this.rescheduleScheduled = !0, setTimeout(() => {
			this.rescheduleScheduled = !1;
			let e = this.getCheckedFrequency();
			e && this.emit(e);
		}, 0));
	};
	setupHidden = () => {
		let e = () => {
			let e = this.getCheckedFrequency();
			e && this.emit(e);
		};
		document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", e, { once: !0 }) : e();
	};
	addGlobalClass = () => {
		let e = this.frequencyEl?.querySelectorAll("input[type=\"radio\"]"), t = () => {
			let e = this.getCheckedFrequency();
			e && this.emit(e);
		};
		document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", t, { once: !0 }) : t(), e?.forEach((e) => {
			e.addEventListener("change", () => this.emit(e.value));
		});
		let n = document.querySelector(_);
		n?.addEventListener("change", this.scheduleReEvaluate), n?.addEventListener("input", this.scheduleReEvaluate);
	};
};
function b() {
	new y();
}
//#endregion
//#region src/modules/Header.ts
function x() {
	let e = document.querySelector("header");
	if (!e) {
		o.info("Header: no <header> found; --header-height stays at its token default");
		return;
	}
	let t = () => {
		let { position: t } = getComputedStyle(e), n = t === "sticky" || t === "fixed" ? e.getBoundingClientRect().height : 0;
		document.documentElement.style.setProperty("--header-height", `${Math.round(n)}px`);
	};
	t(), new ResizeObserver(t).observe(e);
}
//#endregion
//#region src/modules/GiftSummary.ts
var S = class {
	element = null;
	submitButton = null;
	frequencySpan = null;
	submitFrequencySpan = null;
	frequencyText;
	constructor(e) {
		this.frequencyText = e?.frequencyText ?? {}, this.element = document.querySelector(".gift-summary"), this.submitButton = document.querySelector(".en__submit button") || null, this.init();
	}
	init() {
		if (this.element) {
			if (this.element) {
				let e = this.element.innerHTML;
				e.includes("{frequency}") && (this.element.innerHTML = e.replace(/\{frequency\}/g, "<span class=\"frequency\">{frequency}</span>")), this.frequencySpan = this.element.querySelector(".frequency");
			}
			if (this.submitButton) {
				let e = this.submitButton.innerHTML;
				e.includes("{frequency}") && (this.submitButton.innerHTML = e.replace(/\{frequency\}/g, "<span class=\"frequency\">{frequency}</span>")), this.submitFrequencySpan = this.submitButton.querySelector(".frequency");
			}
			this.addEventListeners();
		}
	}
	addEventListeners() {
		document.body.addEventListener("frequency-change", (e) => {
			let t = e.detail.frequency;
			this.updateFrequencyText(t);
		});
	}
	updateFrequencyText(e) {
		let t = e, n = this.frequencyText[t] ?? "";
		this.frequencySpan && (this.frequencySpan.textContent = n), this.submitFrequencySpan && (this.submitFrequencySpan.textContent = n);
	}
}, C = class {
	defaultText;
	position = "bottom";
	arrowPosition = "right";
	customFieldSelector;
	autoHide = !0;
	nudge = null;
	baseText = "";
	activeText = null;
	paragraph = null;
	constructor(e) {
		this.defaultText = e.defaultText, this.position = e.position ?? "bottom", this.arrowPosition = e.arrowPosition ?? "right", this.customFieldSelector = e.customFieldSelector, this.autoHide = e.autoHide ?? !e.recurringActiveText, this.init(e);
	}
	init(e) {
		this.baseText = this.resolveText(e.defaultText, e.customFieldSelector), e.recurringActiveText && (this.activeText = this.resolveText(e.recurringActiveText.default, e.recurringActiveText.customFieldSelector), this.autoHide && o.info("RecurringGiftNudge: autoHide is on alongside recurringActiveText, so the alternate copy will be hidden the moment it applies — set autoHide: false to show it")), this.nudge = this.createNudgeElement(), this.placeNudge(), this.autoHide && this.nudge?.classList.add("auto-hide"), this.activeText && (this.nudge?.classList.add("has-recurring-active-text"), e.recurringActiveText?.arrow && this.nudge?.classList.add("keeps-arrow"), this.watchFrequency());
	}
	resolveText(e, t) {
		if (!t) return e;
		let n = document.querySelector(t);
		if (!n) return e;
		let r = n.value?.trim();
		return n.disabled = !0, r || e;
	}
	createNudgeElement() {
		let e = document.createElement("div");
		return e.classList.add("recurring-gift-nudge", `recurring-gift-nudge-${this.position}`, `recurring-gift-nudge-arrow-${this.arrowPosition}`), e.innerHTML = `<p>${this.baseText}</p>`, this.paragraph = e.querySelector("p"), e;
	}
	watchFrequency() {
		this.applyText(document.body.classList.contains("recurring")), document.body.addEventListener("frequency-change", (e) => {
			let t = e.detail.frequency;
			this.applyText(t !== "ONE_TIME");
		});
	}
	applyText(e) {
		this.paragraph && (this.paragraph.innerHTML = e && this.activeText ? this.activeText : this.baseText);
	}
	placeNudge() {
		if (!this.nudge) return;
		if (this.position === "linked") {
			let e = document.querySelector(".en__field--recurrfreq input[value=\"MONTHLY\"]")?.closest(".en__field__item");
			if (!e) return;
			e.classList.add("has-linked-nudge"), this.arrowPosition === "left" && e.classList.add("has-linked-nudge-arrow-left"), e.appendChild(this.nudge);
			return;
		}
		let e = document.querySelector(".en__field--recurrfreq"), t = e?.parentElement;
		if (!(!e || !t)) {
			if (this.position === "top") {
				t.insertBefore(this.nudge, e);
				return;
			}
			if (this.position === "bottom") {
				t.insertBefore(this.nudge, e.nextSibling);
				return;
			}
		}
	}
}, w = class {
	containerSelector;
	watchTimeoutMs;
	mo = null;
	timeoutId = null;
	listeners = /* @__PURE__ */ new Set();
	started = !1;
	constructor(e = {}) {
		this.containerSelector = e.containerSelector ?? "#en__digitalWallet__stripeButtons__container", this.watchTimeoutMs = e.watchTimeoutMs ?? 12e4;
	}
	snapshot() {
		let e = this.isConfigured(), t = this.platformWallet();
		return {
			wallet: t,
			configured: e,
			confidence: this.estimateConfidence(t, e)
		};
	}
	start() {
		if (!this.started) {
			if (this.started = !0, this.isConfigured()) {
				this.emit(!0);
				return;
			}
			this.mo = new MutationObserver(() => {
				this.isConfigured() && (this.emit(!0), this.stop());
			}), this.mo.observe(document.documentElement, {
				childList: !0,
				subtree: !0
			}), this.timeoutId = window.setTimeout(() => this.stop(), this.watchTimeoutMs);
		}
	}
	stop() {
		this.mo?.disconnect(), this.mo = null, this.timeoutId !== null && (window.clearTimeout(this.timeoutId), this.timeoutId = null), this.started = !1;
	}
	onConfigured(e) {
		return this.listeners.add(e), () => this.listeners.delete(e);
	}
	getContainer() {
		return document.querySelector(this.containerSelector);
	}
	isConfigured() {
		let e = this.getContainer();
		return e ? !!e.querySelector("iframe[src*=\"js.stripe.com\"][src*=\"payment-request\"]") : !1;
	}
	platformWallet() {
		if (window.ApplePaySession !== void 0) return "apple";
		let e = navigator.userAgent, t = /\bAndroid\b/i.test(e) || /android/i.test(navigator.userAgentData?.platform || ""), n = /\bChrome\/\d+/.test(e) && !/\bEdg\//.test(e) && !/\bOPR\//.test(e);
		return t || n ? "google" : "unknown";
	}
	estimateConfidence(e, t) {
		return e === "apple" ? t ? .9 : .7 : e === "google" ? t ? .75 : .55 : t ? .4 : .25;
	}
	emit(e) {
		let t = this.snapshot();
		for (let n of this.listeners) try {
			n(e, t);
		} catch {}
	}
}, T = class {
	constructor() {
		this.init();
	}
	init() {
		let e = this.getInputTypeAndElement();
		if (!e) return;
		let { type: t, element: n } = e;
		switch (t) {
			case "hidden":
				this.setupHiddenInput(n);
				break;
			case "select":
				this.setupSelect(n);
				break;
			case "radio":
				this.setupRadio(n);
				break;
		}
		this.addACHInputMasks(), this.restorePaymentType();
	}
	getInputTypeAndElement() {
		let e = document.querySelector("input[name=\"transaction.paymenttype\"].en__field__input--hidden");
		if (e) return {
			type: "hidden",
			element: e
		};
		let t = document.querySelector(".en__field--paymenttype:has(.en__field__input--select)");
		if (t) return {
			type: "select",
			element: t
		};
		let n = document.querySelector(".en__field--paymenttype:has(.en__field__input--radio)");
		return n ? {
			type: "radio",
			element: n
		} : null;
	}
	updatePaymentType(e) {
		let t = Array.from(document.body.classList).filter((e) => e.startsWith("paymenttype-"));
		document.body.classList.remove(...t), document.body.classList.add(`paymenttype-${e.toLowerCase().replace("_", "-")}`), this.savePaymentType(e);
	}
	setupHiddenInput(e) {
		let t = e.value || "card";
		this.updatePaymentType(t);
	}
	setupSelect(e) {
		let t = e.querySelector(".en__field__input--select");
		t && (t.addEventListener("change", (e) => {
			let t = e.target;
			this.updatePaymentType(t.value);
		}), this.updatePaymentType(t.value));
	}
	setupRadio(e) {
		e.querySelectorAll(".en__field__input--radio").forEach((e) => {
			e.addEventListener("change", (e) => {
				let t = e.target;
				t.checked && this.updatePaymentType(t.value);
			}), e.checked && this.updatePaymentType(e.value);
		}), this.setupInlineDigitalWallets();
	}
	setupInlineDigitalWallets() {
		let e = document.querySelector(".en__field__input--radio[value=\"digital\"] + label"), t = new w({
			containerSelector: "#en__digitalWallet__stripeButtons__container",
			watchTimeoutMs: 12e4
		}), n = t.snapshot();
		if (document.documentElement.dataset.walletEarly = n.wallet, document.documentElement.dataset.walletConfigured = String(n.configured), e && n.wallet !== "unknown") {
			let t = e.textContent || "";
			e.textContent = "";
			let r = document.createElement("span");
			r.classList.add("sr-only"), r.textContent = t, e.appendChild(r), n.wallet === "apple" && (e.textContent = "Apple Pay", e.classList.add("apple-pay-button")), n.wallet === "google" && (e.textContent = "Google Pay", e.classList.add("google-pay-button"));
		}
		t.onConfigured((e, t) => {
			document.documentElement.dataset.walletConfigured = String(t.configured);
		}), t.start();
	}
	addACHInputMasks() {
		let e = document.getElementById("en__field_supporter_bankAccountNumber"), t = document.getElementById("en__field_supporter_bankRoutingNumber");
		e && p(e), t && m(t);
	}
	savePaymentType(e) {
		sessionStorage.setItem("paymentType", e);
	}
	restorePaymentType() {
		if (!new URLSearchParams(window.location.search).has("val")) return;
		let e = sessionStorage.getItem("paymentType");
		if (!e) return;
		let t = document.querySelector(`.en__field__input--radio[value="${e}"]`);
		if (t) {
			t.checked = !0, t.dispatchEvent(new Event("change", { bubbles: !0 }));
			return;
		}
		let n = document.querySelector(".en__field--paymenttype .en__field__input--select");
		n && (n.value = e, n.dispatchEvent(new Event("change", { bubbles: !0 })));
	}
};
function E() {
	new T();
}
//#endregion
//#region src/modules/Radio.ts
var D = class {
	field;
	observer = null;
	boundOtherInputs = /* @__PURE__ */ new WeakSet();
	constructor(e) {
		this.field = e, this.field && this.init();
	}
	destroy() {
		this.observer?.disconnect(), this.observer = null;
	}
	init() {
		this.field.classList.contains("en__field--withOther") && this.setupOther(), this.handleSwapList();
	}
	setupOther() {
		let e = this.field.querySelector(".en__field__input--other");
		e && (this.boundOtherInputs.has(e) || (e.addEventListener("input", () => {
			let t = this.field.querySelector(".en__field__input--radio[value=\"Other\"]");
			t && (t.checked = !0), e.dispatchEvent(new Event("change", { bubbles: !0 }));
		}), this.boundOtherInputs.add(e)), e.placeholder ||= "Other");
	}
	handleSwapList() {
		let e = this.field.querySelector(".en__field__element--radio");
		e && (this.observer = new MutationObserver((e) => {
			e.some((e) => e.type === "childList" && e.addedNodes.length > 0) && this.setupOther();
		}), this.observer.observe(e, {
			childList: !0,
			subtree: !0
		}));
	}
};
function O() {
	document.querySelectorAll(".en__field--radio").forEach((e) => new D(e));
}
//#endregion
//#region src/modules/CharacterCounter.ts
var k = class {
	input;
	maxLength;
	el;
	constructor(e, t) {
		this.input = e;
		let n = e.getAttribute("maxlength");
		n === null ? t === void 0 ? this.maxLength = null : this.maxLength = t : this.maxLength = parseInt(n, 10), this.maxLength !== null && !e.hasAttribute("maxlength") && e.setAttribute("maxlength", String(this.maxLength)), this.el = this.createElement(), this.mount(), this.update(), this.input.addEventListener("input", () => this.update());
	}
	createElement() {
		let e = document.createElement("span");
		return e.className = "character-counter", e.setAttribute("aria-live", "polite"), e.setAttribute("aria-atomic", "true"), e;
	}
	mount() {
		this.input.insertAdjacentElement("afterend", this.el);
	}
	get currentLength() {
		return this.input.value.length;
	}
	update() {
		let e = this.currentLength;
		if (this.maxLength !== null) {
			let t = this.maxLength - e;
			this.el.textContent = `${e} / ${this.maxLength}`, this.el.dataset.remaining = String(t), this.el.classList.toggle("character-counter--warning", t <= 20 && t > 0), this.el.classList.toggle("character-counter--exceeded", t < 0), this.el.classList.remove(t > 20 ? "character-counter--warning" : "");
		} else this.el.textContent = `${e}`, this.el.dataset.remaining = "";
	}
	setMaxLength(e) {
		this.maxLength = e, this.update();
	}
}, A = class {
	element;
	counter;
	constructor(e, t = {}) {
		if (!(e instanceof HTMLTextAreaElement)) throw TypeError("Textarea: first argument must be an HTMLTextAreaElement.");
		this.element = e, this.counter = new k(e, t.maxLength);
	}
	setMaxLength(e) {
		this.counter.setMaxLength(e), e === null ? this.element.removeAttribute("maxlength") : this.element.setAttribute("maxlength", String(e));
	}
};
function j() {
	document.querySelectorAll(".en__field__input--textarea").forEach((e) => new A(e, { maxLength: 250 }));
}
//#endregion
//#region src/modules/BackgroundImage.ts
var M = "zuri-en:bg-images-seen", N = class {
	constructor() {
		o.log("BackgroundImage module initialized"), this.init();
	}
	init() {
		let e = document.querySelector(".background-image");
		if (!e) return;
		let t = Array.from(e.querySelectorAll("img")).filter((e) => e.src);
		if (t.length === 0) return;
		let n = this.pickImage(t), r = document.querySelector("main");
		r && (r.style.setProperty("--bg-image", `url('${CSS.escape(n.src)}')`), r.classList.add("has-background-image"), this.markSeen(n.src), e.classList.contains("background-image-caption") && this.addCaption(n), e.setAttribute("aria-hidden", "true"), e.style.display = "none");
	}
	addCaption(e) {
		let t = e.alt?.trim();
		if (!t) return;
		let n = document.createElement("p");
		n.className = "bg-image-caption", n.textContent = t, document.body.appendChild(n), e.alt = "Page background image";
		let r = document.querySelector("footer");
		if (r) {
			let e = () => {
				let e = Math.max(0, window.innerHeight - r.getBoundingClientRect().top);
				n.style.bottom = e > 0 ? `${e + 12}px` : "";
			};
			window.addEventListener("scroll", e, { passive: !0 }), window.addEventListener("resize", e, { passive: !0 }), new ResizeObserver(e).observe(document.body), e();
		}
	}
	pickImage(e) {
		let t = this.getSeen(), n = e.filter((e) => !t.includes(e.src));
		return n.length === 0 && (this.clearSeen(), n = e), n[Math.floor(Math.random() * n.length)];
	}
	getSeen() {
		try {
			let e = localStorage.getItem(M);
			return e ? JSON.parse(e) : [];
		} catch {
			return [];
		}
	}
	markSeen(e) {
		try {
			let t = this.getSeen();
			t.includes(e) || (t.push(e), localStorage.setItem(M, JSON.stringify(t)));
		} catch {}
	}
	clearSeen() {
		try {
			localStorage.removeItem(M);
		} catch {}
	}
};
function P() {
	document.querySelector(".background-image") && new N();
}
//#endregion
//#region src/modules/Alert.ts
var F = class {
	errorList;
	observer = null;
	suppressObserver = !1;
	constructor() {
		this.errorList = document.querySelector(".en__errorList"), this.init();
	}
	destroy() {
		this.observer?.disconnect(), this.observer = null;
	}
	init() {
		this.checkForAlerts(), this.observeAlerts();
	}
	checkForAlerts() {
		let e = this.errorList?.querySelectorAll("li");
		if (e && e.length > 0) {
			let t = Array.from(e).map((e) => e.textContent ?? "");
			this.createAlertPopup(t);
		}
	}
	observeAlerts() {
		this.errorList && (this.observer = new MutationObserver(() => {
			this.suppressObserver || this.checkForAlerts();
		}), this.observer.observe(this.errorList, { childList: !0 }));
	}
	createAlertPopup(e) {
		let t = document.querySelector(".alert-popup");
		t && t.remove();
		let n = document.createElement("div");
		n.className = "alert-popup-overlay";
		let r = document.createElement("div");
		r.className = "alert-popup", r.setAttribute("role", "alertdialog"), r.setAttribute("aria-label", "Form errors");
		let i = document.createElement("p");
		i.className = "alert-popup-heading", i.textContent = "Please correct the following:";
		let a = document.createElement("ul");
		a.className = "alert-popup-list";
		for (let t of e) {
			let e = document.createElement("li");
			e.textContent = t, a.appendChild(e);
		}
		let o = document.createElement("button");
		o.className = "alert-popup-dismiss btn", o.type = "button", o.textContent = "OK", o.addEventListener("click", () => {
			this.dismissAlert(n);
		}), r.appendChild(i), r.appendChild(a), r.appendChild(o), n.appendChild(r), document.body.appendChild(n), o.focus();
	}
	dismissAlert(e) {
		e.remove();
		let t = this.errorList?.querySelectorAll("li");
		t && (this.suppressObserver = !0, Array.from(t).forEach((e) => e.remove()), queueMicrotask(() => {
			this.suppressObserver = !1;
		}));
	}
};
function I() {
	new F();
}
//#endregion
//#region src/modules/Sidebar.ts
var L = {
	position: "right",
	mobilePosition: "below",
	variant: "plain"
}, R = class {
	row;
	form;
	mainContent;
	position;
	mobilePosition;
	variant;
	constructor(e = {}) {
		if (this.position = e.position ?? L.position, this.mobilePosition = e.mobilePosition ?? L.mobilePosition, this.variant = e.variant ?? L.variant, this.row = document.querySelector(".en__component--advrow.sidebar"), this.form = document.querySelector("form.en__component--page"), this.mainContent = document.querySelector(".main-content"), !this.row || !this.form || !this.mainContent) {
			o.info("Sidebar: row, form, or main-content not found; skipping");
			return;
		}
		this.relocate(this.row, this.form, this.mainContent);
	}
	relocate(e, t, n) {
		let r = this.buildAside(e);
		if (!r) {
			o.info("Sidebar: no content found in sidebar row; skipping");
			return;
		}
		n.insertBefore(r, t), n.classList.add("has-sidebar"), n.dataset.sidebarPosition = this.position, n.dataset.sidebarMobile = this.mobilePosition, n.dataset.sidebarVariant = this.variant, e.remove();
	}
	buildAside(e) {
		let t = e.querySelectorAll(".en__component--advcolumn > .en__component");
		if (t.length === 0) return null;
		let n = document.createElement("aside");
		return n.className = "sidebar", n.dataset.variant = this.variant, n.setAttribute("aria-label", "About your gift"), t.forEach((e) => n.appendChild(e)), n;
	}
}, z = "split-gift.amount", B = "split-gift.amount.other", V = class {
	designations;
	mapByValue;
	amountLabel;
	otherPlaceholder;
	addLabel;
	addAnotherLabel;
	select;
	source;
	form;
	picker;
	summary;
	summaryBody;
	addButtonText;
	error = null;
	removeLabel = "remove";
	defaultDesignation = "0";
	gifts = /* @__PURE__ */ new Map();
	constructor(e = {}) {
		this.designations = e.designations ?? [], this.mapByValue = new Map(this.designations.map((e) => [e.value, e])), this.amountLabel = e.amountLabel ?? "Gift Amount", this.otherPlaceholder = e.otherPlaceholder ?? "Other", this.addLabel = e.addLabel ?? "Add Gift", this.addAnotherLabel = e.addAnotherLabel ?? "Add Another Gift", this.init();
	}
	init() {
		let e = document.querySelector(".en__field--donationAmt");
		if (!e) {
			o.info("SplitGift: no donation amount field on this page; skipping");
			return;
		}
		let t = document.querySelector(".en__field--gift-designation select"), n = document.querySelector(".split-gift-summary"), r = n?.querySelector(".split-gift-summary__body");
		if (!t || !n || !r || this.designations.length === 0) {
			console.warn(W({
				select: !!t,
				summary: !!n,
				summaryBody: !!r,
				designations: this.designations.length > 0
			}));
			return;
		}
		let i = t.closest("form");
		if (!i) {
			o.info("SplitGift: enclosing form not found; skipping");
			return;
		}
		this.select = t, this.source = e, this.form = i, this.defaultDesignation = t.options[0]?.value ?? "0", this.summary = n, this.summaryBody = r, this.error = n.querySelector(".split-gift-summary__error"), this.removeLabel = n.dataset.removeLabel?.trim() || this.removeLabel, this.picker = this.buildAmountPicker(e), this.mount(), this.wire(), this.watchValidation(), this.render(), this.writeFields(), document.body.classList.add("split-gift-active");
	}
	buildAmountPicker(e) {
		let t = document.createElement("div");
		t.className = "split-gift__amount";
		for (let n of [
			"--suffix-one-time",
			"--suffix-monthly",
			"--suffix-quarterly",
			"--suffix-annual"
		]) {
			let r = e.style.getPropertyValue(n);
			r && t.style.setProperty(n, r);
		}
		let n = document.createElement("span");
		n.className = "split-gift__label", n.textContent = this.amountLabel, t.appendChild(n);
		let r = document.createElement("div");
		r.className = "split-gift__options", t.appendChild(r), e.querySelectorAll("input[name=\"transaction.donationAmt\"][type=\"radio\"]").forEach((t) => {
			if (t.value === "Other") return;
			let n = document.createElement("label");
			n.className = "split-gift__pill";
			let i = document.createElement("input");
			i.type = "radio", i.className = "split-gift__radio", i.name = z, i.value = t.value, i.checked = t.checked;
			let a = document.createElement("span");
			a.className = "split-gift__pill-text", a.textContent = this.labelFor(e, t) ?? t.value, n.append(i, a), r.appendChild(n);
		});
		let i = document.createElement("label");
		i.className = "split-gift__pill split-gift__pill--other";
		let a = document.createElement("input");
		a.type = "radio", a.className = "split-gift__radio", a.name = z, a.value = "Other", a.hidden = !0;
		let o = document.createElement("input");
		return o.type = "text", o.className = "split-gift__other", o.name = B, o.inputMode = "decimal", o.autocomplete = "off", o.placeholder = this.otherPlaceholder, i.append(a, o), r.appendChild(i), t;
	}
	labelFor(e, t) {
		if (t.id) {
			let n = e.querySelector(`label[for="${t.id}"]`);
			if (n?.textContent?.trim()) return n.textContent.trim();
		}
		return (t.closest(".en__field__item")?.querySelector(".en__field__label--item"))?.textContent?.trim() ?? null;
	}
	mount() {
		this.source.classList.add("split-gift__source");
		let e = document.createElement("div");
		e.className = "split-gift", e.appendChild(this.picker), e.appendChild(this.buildAddButton()), this.source.insertAdjacentElement("afterend", e);
		let t = this.summary.closest(".en__component--codeblock");
		e.insertAdjacentElement("afterend", this.summary), t && t.children.length === 0 && (t.hidden = !0);
	}
	watchValidation() {
		let e = this.error;
		if (!e) return;
		let t = () => {
			let t = this.source.querySelector(".en__field__error")?.textContent?.trim() ?? "";
			e.textContent = t, e.hidden = t === "";
		};
		new MutationObserver(t).observe(this.source, {
			childList: !0,
			subtree: !0,
			characterData: !0,
			attributes: !0,
			attributeFilter: ["class"]
		}), t();
	}
	buildAddButton() {
		let e = document.createElement("button");
		return e.type = "button", e.className = "split-gift__add", e.innerHTML = `<span>${H(this.addLabel)}</span>
      <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
        <circle cx="12" cy="12" r="9"></circle>
        <path d="M12 8v8M8 12h8" stroke-linecap="round"></path>
      </svg>`, this.addButtonText = e.querySelector("span"), e.addEventListener("click", () => this.onAdd()), e;
	}
	wire() {
		let e = this.picker.querySelector(`input[name="${B}"]`);
		e && (e.value = "", f(e), e.addEventListener("input", () => {
			let e = this.picker.querySelector(`input[name="${z}"][value="Other"]`);
			e && (e.checked = !0);
		})), this.summaryBody.addEventListener("click", (e) => {
			let t = e.target.closest(".split-gift-summary__remove");
			if (!t) return;
			let n = t.dataset.value;
			n && this.gifts.delete(n) && (this.render(), this.writeFields());
		});
	}
	onAdd() {
		let e = this.readAmount();
		if (e <= 0) return;
		let t = this.select.value;
		if (!this.mapByValue.has(t)) {
			o.warn("SplitGift: no field mapping for designation", t);
			return;
		}
		let n = this.select.options[this.select.selectedIndex]?.text ?? t, r = this.gifts.get(t);
		this.gifts.set(t, {
			label: n,
			amount: (r?.amount ?? 0) + e
		}), this.render(), this.writeFields(), this.resetSelect();
	}
	readAmount() {
		let e = this.picker.querySelector(`input[name="${z}"]:checked`);
		if (!e) return 0;
		let t = e.value === "Other" ? this.picker.querySelector(`input[name="${B}"]`)?.value ?? "" : e.value, n = parseFloat(t);
		return Number.isFinite(n) && n > 0 ? n : 0;
	}
	render() {
		let e = [...this.gifts.entries()];
		this.summary.classList.toggle("split-gift-summary--empty", e.length === 0), this.addButtonText.textContent = e.length ? this.addAnotherLabel : this.addLabel, this.summaryBody.querySelectorAll(".split-gift-summary__row").forEach((e) => e.remove());
		for (let [t, n] of e) {
			let e = document.createElement("tr");
			e.className = "split-gift-summary__row", e.innerHTML = `
        <td>${H(n.label)}</td>
        <td>
          <span class="split-gift-summary__amount">${n.amount.toFixed(2)}</span>
          <button type="button" class="split-gift-summary__remove" data-value="${H(t)}">${H(this.removeLabel)}</button>
        </td>`, this.summaryBody.appendChild(e);
		}
	}
	writeFields() {
		let e = 0;
		for (let { value: t, field: n } of this.designations) {
			let r = this.gifts.get(t)?.amount ?? 0;
			e += r;
			let i = this.form.querySelector(`[name="${n}"]`);
			i && (i.value = r > 0 ? r.toFixed(2) : "");
		}
		this.setTotal(e);
	}
	setTotal(e) {
		let t = this.source.querySelector("input[name=\"transaction.donationAmt\"][value=\"Other\"]"), n = this.source.querySelector("input[name=\"transaction.donationAmt.other\"]");
		!t || !n || (n.value = e > 0 ? e.toFixed(2) : "", t.click(), n.dispatchEvent(new Event("input", { bubbles: !0 })), n.dispatchEvent(new Event("change", { bubbles: !0 })));
	}
	resetSelect() {
		this.select.value = this.defaultDesignation, this.select.dispatchEvent(new Event("change", { bubbles: !0 }));
	}
};
function H(e) {
	return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
var U = "<div class=\"split-gift-summary\" data-remove-label=\"remove\">\n  <h3 class=\"split-gift-summary__title\">Your Gifts</h3>\n  <table class=\"split-gift-summary__table\">\n    <thead>\n      <tr>\n        <th scope=\"col\">Area of Need</th>\n        <th scope=\"col\">Amount</th>\n      </tr>\n    </thead>\n    <tbody class=\"split-gift-summary__body\">\n      <tr class=\"split-gift-summary__empty\">\n        <td colspan=\"2\">Add an area above to start your gift.</td>\n      </tr>\n    </tbody>\n  </table>\n  <div class=\"split-gift-summary__total\">\n    <span>Your Total Gift</span>\n    <span class=\"split-gift-summary__total-value\">{amount-total}</span>\n  </div>\n  <div class=\"split-gift-summary__error\" role=\"alert\" hidden></div>\n</div>";
function W(e) {
	let t = [];
	return e.select || t.push("Designation field is missing. In the EN page builder, open the gift-designation question and add the CSS class \"gift-designation\" to it, so it renders as <div class=\"en__field--gift-designation\"> with a <select> inside."), e.summary ? e.summaryBody || t.push("Gift summary block has no <tbody class=\"split-gift-summary__body\">, which is where the gift rows are written. Restore it:\n\n" + U) : t.push("Gift summary block is missing. Add a code block to the donation step containing:\n\n" + U), e.designations || t.push("No designations are mapped. In the consumer config, set splitGift.designations to one { value, field } pair per designation <option> — e.g. [{ value: '1', field: 'transaction.othamt2' }]."), `[zuri-en] splitGift is enabled but split gift did not run. Fix ${t.length === 1 ? "this" : "these"} and reload:\n\n` + t.map((e, t) => `${t + 1}. ${e}`).join("\n\n") + "\n\nBoth the designation field and the summary block are required — see the \"gift summary code block\" section of the @zuri/en README.";
}
//#endregion
//#region src/modules/Hero.ts
var G = "zuri-en:hero-images-seen", K = class {
	hero;
	insertTarget;
	constructor() {
		if (this.hero = document.querySelector(".hero"), this.insertTarget = document.querySelector("main"), !this.hero || !this.insertTarget) {
			o.info("Hero: hero row or main not found; skipping");
			return;
		}
		this.setP2PBanner(this.hero) || this.pickRandomImage(this.hero), this.insertHero(this.hero, this.insertTarget);
	}
	setP2PBanner(e) {
		let t = new URLSearchParams(window.location.search).get("bannerImage");
		if (!t) return !1;
		let n = t;
		try {
			n = new URL(t, window.location.origin).href;
		} catch {
			return o.info("Hero: bannerImage is not a valid URL; skipping"), !1;
		}
		let r = Array.from(e.querySelectorAll(".en__component--imageblock"));
		if (r.length === 0) return !1;
		let [i, ...a] = r;
		a.forEach((e) => e.remove());
		let s = i.querySelector("img");
		return s ? (s.src = n, s.srcset = "", o.info(`Hero: applied P2P banner ${n}`), !0) : !1;
	}
	pickRandomImage(e) {
		let t = Array.from(e.querySelectorAll(".en__component--imageblock")).filter((e) => e.querySelector("img")?.src);
		if (t.length === 0) return;
		let n = this.pickBlock(t), r = n.querySelector("img")?.src;
		t.forEach((e) => {
			e !== n && e.remove();
		}), r && this.markSeen(r);
	}
	pickBlock(e) {
		let t = this.getSeen(), n = e.filter((e) => !t.includes(e.querySelector("img")?.src ?? ""));
		return n.length === 0 && (this.clearSeen(), n = e), n[Math.floor(Math.random() * n.length)];
	}
	getSeen() {
		try {
			let e = localStorage.getItem(G);
			return e ? JSON.parse(e) : [];
		} catch {
			return [];
		}
	}
	markSeen(e) {
		try {
			let t = this.getSeen();
			t.includes(e) || (t.push(e), localStorage.setItem(G, JSON.stringify(t)));
		} catch {}
	}
	clearSeen() {
		try {
			localStorage.removeItem(G);
		} catch {}
	}
	insertHero(e, t) {
		t.classList.add("has-hero"), t.insertAdjacentElement("afterbegin", e);
	}
}, q = class {
	upsell = null;
	matchedRule = null;
	giftPage;
	upsellElement = null;
	currentAmount = 0;
	upsellAmount = 0;
	onComplete = null;
	constructor() {
		this.giftPage = document.querySelector(".en__field--donationAmt")?.closest(".step"), this.init();
	}
	init() {
		let e = window.EngagingNetworks?.upsell;
		if (!e?.length) return;
		let t = JSON.parse(e[0].jsonContent);
		!t.single || t.single.enable || (document.body.classList.add("embedded-upsell"), this.upsell = t.single);
	}
	getCurrentGiftAmount() {
		let e = document.querySelector("[data-token=\"amount-total\"]"), t = parseFloat(e?.textContent?.replace("$", "") || "0");
		return isNaN(t) ? 0 : t;
	}
	setRecurringAndUpdateGift(e) {
		document.querySelector("input[name=\"transaction.recurrfreq\"][value=\"MONTHLY\"]")?.click();
		let t = document.querySelectorAll(".en__field--donationAmt input[type=\"radio\"]"), n = Array.from(t).find((t) => t.value === e.toString());
		if (n) {
			n.click();
			return;
		}
		let r = document.querySelector("input[name=\"transaction.donationAmt\"][value=\"Other\"]"), i = document.querySelector(".en__field--donationAmt input[name=\"transaction.donationAmt.other\"]");
		!i || !r || (i.value = e.toString(), r.click(), i.dispatchEvent(new Event("change", { bubbles: !0 })));
	}
	findMatchingRule(e) {
		return this.upsell ? this.upsell.rules.find((t) => {
			let n = Number(t.triggerMin), r = Number(t.triggerMax);
			return Number.isNaN(n) || Number.isNaN(r) ? !1 : e >= n && e <= r;
		}) ?? null : null;
	}
	tryShow() {
		if (o.log("Trying to determine if embedded upsell should be shown..."), !this.upsell) return !1;
		o.log("Current gift amount:", this.getCurrentGiftAmount());
		let e = this.getCurrentGiftAmount();
		if (e === 0) return !1;
		let t = document.querySelector(".en__field__input--radio[name=\"transaction.recurrfreq\"]:checked");
		if (o.log("Checked recurring option:", t?.value), t?.value !== "ONE_TIME") return !1;
		let n = this.findMatchingRule(e);
		return n ? (this.matchedRule = n, o.log("Matched upsell rule range:", n.triggerMin, "to", n.triggerMax), o.log("Upsell conditions met. Showing upsell..."), this.showUpsell(), !0) : (o.log("No upsell rule matched the current gift amount."), !1);
	}
	calculateUpsellAmount() {
		if (!this.upsell) return;
		this.currentAmount = this.getCurrentGiftAmount();
		let e = this.matchedRule;
		if (!e) return;
		let t = Number(e.upsellValue);
		if (e.upsellType === "flat amount") {
			this.upsellAmount = t;
			return;
		}
		if (e.upsellType === "% of the original amount") {
			let n = Number(e.roundValue) || 1, r = this.currentAmount * (t / 100);
			e.roundType === "up" ? this.upsellAmount = Math.ceil(r / n) * n : e.roundType === "down" ? this.upsellAmount = Math.floor(r / n) * n : this.upsellAmount = Math.round(r / n) * n;
		}
	}
	complete() {
		this.upsellElement?.remove(), this.upsellElement = null, document.body.classList.remove("upsell-active"), this.onComplete?.();
	}
	formatAmount(e) {
		return `$${e.toFixed(2)}`;
	}
	destroy() {
		this.upsellElement?.remove(), document.body.classList.remove("embedded-upsell", "upsell-active");
	}
	fillPlaceholders(e) {
		return e.replace("{upsell_amount}", this.formatAmount(this.upsellAmount)).replace("{current_amount}", this.formatAmount(this.currentAmount));
	}
	showUpsell() {
		if (!this.upsell) return;
		document.body.classList.add("upsell-active"), this.calculateUpsellAmount(), this.upsellElement?.remove();
		let e = document.createElement("div");
		if (e.classList.add("upsell", "single-to-recurring-upsell"), this.upsell.imageUrl) {
			let t = document.createElement("img");
			t.src = this.upsell.imageUrl, t.alt = "Upsell Image", e.appendChild(t);
		}
		if (this.upsell.content) {
			let t = document.createElement("div");
			t.classList.add("upsell-content"), t.innerHTML = this.fillPlaceholders(this.upsell.content), e.appendChild(t);
		}
		let t = document.createElement("button");
		t.classList.add("upsell-decline-button", "btn"), t.textContent = this.fillPlaceholders(this.upsell.declineButtonLabel), t.addEventListener("click", () => this.complete());
		let n = document.createElement("button");
		n.classList.add("upsell-accept-button", "btn"), n.textContent = this.fillPlaceholders(this.upsell.acceptButtonLabel), n.addEventListener("click", () => {
			this.upsellAmount && this.setRecurringAndUpdateGift(this.upsellAmount), this.complete();
		});
		let r = document.createElement("div");
		r.classList.add("upsell-buttons"), r.append(t, n), e.append(r), this.upsellElement = e, this.giftPage && (this.giftPage.insertAdjacentElement("afterend", e), setTimeout(() => e.classList.add("show"), 300));
	}
}, J = class {
	element;
	progress;
	stepIndicators;
	totalSteps;
	hiddenIndices;
	constructor(e) {
		this.element = e, this.progress = this.element.querySelector("progress"), this.stepIndicators = Array.from(this.element.querySelectorAll("li")), this.totalSteps = this.stepIndicators.length, this.hiddenIndices = /* @__PURE__ */ new Set(), this.init();
	}
	init() {
		if (!this.progress) return;
		let e = Math.max(this.totalSteps - 1, 1);
		this.progress.max = e, this.progress.value = 0, this.progress.setAttribute("aria-valuemin", "0"), this.progress.setAttribute("aria-valuemax", e.toString()), this.progress.setAttribute("aria-valuenow", "0"), this.progress.setAttribute("aria-valuetext", `Step 1 of ${this.totalSteps}`);
	}
	getStepName(e) {
		return this.stepIndicators[e]?.textContent?.trim() || null;
	}
	setHiddenSteps(e) {
		this.hiddenIndices = new Set(e), this.stepIndicators.forEach((t, n) => {
			t.classList.toggle("hidden!", e.has(n));
		});
	}
	setActiveStep(e) {
		if (this.totalSteps === 0) return;
		let t = this.totalSteps - this.hiddenIndices.size;
		if (t === 0) return;
		let n = Math.min(Math.max(e, 1), t), r = 0;
		this.stepIndicators.forEach((e, t) => {
			if (this.hiddenIndices.has(t)) {
				e.classList.remove("completed", "active");
				return;
			}
			r++, e.classList.toggle("completed", r < n), e.classList.toggle("active", r === n);
		}), this.updateProgressValue(n, t);
	}
	updateProgressValue(e, t) {
		if (!this.progress) return;
		let n = Math.max(t - 1, 1), r = t > 1 ? e - 1 : e;
		this.progress.max = n, this.progress.value = Math.min(r, n), this.progress.setAttribute("aria-valuemax", n.toString()), this.progress.setAttribute("aria-valuenow", this.progress.value.toString()), this.progress.setAttribute("aria-valuetext", `Step ${e} of ${t}`);
	}
}, Y = class {
	element;
	button;
	validators;
	onComplete;
	vgsObservers = [];
	constructor(e, t) {
		this.element = e, this.button = e.querySelector(".next-button, .en__submit button"), this.validators = [], this.onComplete = t ?? null, this.init();
	}
	destroy() {
		this.vgsObservers.forEach((e) => e.disconnect()), this.vgsObservers = [];
	}
	async init() {
		this.setupButton(), this.button && (this.button.disabled = !0), await this.getStepValidators(), this.button && (this.button.disabled = !1), this.setupLiveValidation();
	}
	setupButton() {
		this.button?.addEventListener("click", (e) => {
			e.preventDefault(), this.checkValidity() && this.onComplete?.();
		});
	}
	getStepValidators(e = 25) {
		return new Promise((t) => {
			let n = (e) => {
				let r = window.EngagingNetworks?.require?._defined?.enValidation?.validation?.validators;
				if (Array.isArray(r) && r.length > 0) {
					this.validators = r.filter((e) => {
						let t = document.querySelector(`.en__field--${e.field}`);
						return t && this.element.contains(t);
					}), t();
					return;
				}
				e > 0 ? setTimeout(() => n(e - 1), 100) : (console.warn("[zuri-en] Step: EN validators never became available; step will advance without validation"), t());
			};
			n(e);
		});
	}
	checkVGSField(e, t) {
		let n = e.closest("[class*=\"en__field--\"]")?.classList.contains("en__mandatory"), r = e.classList.contains("vgs-collect-container__empty"), i = e.classList.contains("vgs-collect-container__invalid");
		return t?.hideMessage(), n && r || i ? (t?.showMessage(), !1) : !0;
	}
	checkValidity() {
		let e = this.validators.map((e) => {
			let t = document.querySelector(`.en__field--${e.field}`);
			if (t?.classList.contains("en__field--vgs")) return !0;
			let n = t?.querySelector("input, select, textarea"), r = t?.classList.contains("en__mandatory"), i = n?.value.trim() === "";
			return e.hideMessage(), !r && i ? !0 : !e.isVisible() || e.test();
		}).every(Boolean), t = !0;
		return this.element.querySelectorAll(".en__field__input--vgs").forEach((e) => {
			if (e.offsetParent === null) return;
			let n = e.closest("[class*=\"en__field--\"]"), r = this.validators.find((e) => n?.classList.contains(`en__field--${e.field}`));
			this.checkVGSField(e, r) || (t = !1);
		}), e && t;
	}
	setupLiveValidation() {
		this.validators.forEach((e) => {
			let t = document.querySelector(`.en__field--${e.field}`);
			t && (t.classList.contains("en__field--vgs") ? this.observeVgsField(t, e) : this.setupFieldValidation(t, e));
		});
	}
	observeVgsField(e, t) {
		let n = e.querySelector(".en__field__input--vgs");
		if (!n) return;
		let r = new MutationObserver(() => {
			n.classList.contains("vgs-collect-container__touched") && this.checkVGSField(n, t);
		});
		r.observe(n, {
			attributes: !0,
			attributeFilter: ["class"]
		}), this.vgsObservers.push(r);
	}
	setupFieldValidation(e, t) {
		e.addEventListener("input", () => t.hideMessage()), e.addEventListener("change", () => {
			let n = e.querySelector("input, select, textarea"), r = e.classList.contains("en__mandatory"), i = n?.value.trim() === "";
			t.hideMessage(), (r || !i) && t.test();
		});
	}
}, X = ".en__component--page", Z = class {
	steps;
	backButton;
	currentStep;
	progressBar;
	embeddedUpsell = null;
	config;
	dependencyObserver = null;
	backButtonHandler = null;
	constructor(e = {}) {
		this.config = e, this.currentStep = 0, this.steps = [], this.backButton = document.getElementById("back-button") || null;
		let t = document.querySelector(".progress-bar");
		this.progressBar = t ? new J(t) : null, e.embeddedUpsell && (this.embeddedUpsell = new q()), this.init();
	}
	destroy() {
		this.dependencyObserver?.disconnect(), this.dependencyObserver = null, this.backButton && this.backButtonHandler && (this.backButton.removeEventListener("click", this.backButtonHandler), this.backButtonHandler = null);
	}
	init() {
		this.setupSteps(), this.steps.length > 0 && (this.showStep(0), this.setupBackButton(), this.checkForProcessingError(), this.observeFormDependencies()), this.config.onSetupComplete?.(this);
	}
	observeFormDependencies() {
		let e = document.querySelector(X);
		if (!e) return;
		let t = !1;
		this.dependencyObserver = new MutationObserver(() => {
			t || (t = !0, requestAnimationFrame(() => {
				t = !1, this.updateProgressBar();
			}));
		}), e.querySelectorAll(".en__field").forEach((e) => {
			this.dependencyObserver?.observe(e, {
				attributes: !0,
				attributeFilter: ["class"]
			});
		});
	}
	updateProgressBar() {
		let e = /* @__PURE__ */ new Set(), t = 0;
		for (let n = 0; n < this.steps.length; n++) n !== this.currentStep && this.isStepEmpty(n) && e.add(n), !e.has(n) && n <= this.currentStep && t++;
		this.progressBar?.setHiddenSteps(e), this.progressBar?.setActiveStep(t), this.config.dynamicNextLabels && this.updateNextButtonLabels(), this.config.dynamicBackLabel && this.updateBackButtonLabel();
	}
	updateNextButtonLabels() {
		this.steps.forEach((e, t) => {
			let n = e.element.querySelector(".next-button");
			if (!n) return;
			let r = t + 1;
			for (; r < this.steps.length - 1 && this.isStepEmpty(r);) r++;
			let i = this.progressBar?.getStepName(r);
			i && (n.textContent = `Next: ${i}`);
		});
	}
	updateBackButtonLabel() {
		if (!this.backButton || this.currentStep === 0) return;
		let e = this.currentStep - 1;
		for (; e > 0 && this.isStepEmpty(e);) e--;
		let t = this.progressBar?.getStepName(e);
		t && (this.backButton.textContent = `Back to ${t}`);
	}
	setupSteps() {
		let e = document.querySelector(X), t = document.querySelectorAll(".step");
		(t.length ? t : e ? [e] : []).forEach((e) => {
			let t = new Y(e, () => this.advance());
			this.steps.push(t);
		});
	}
	setupBackButton() {
		this.backButton && (this.backButtonHandler = () => {
			if (this.currentStep > 0) {
				let e = this.currentStep - 1;
				for (; e > 0 && this.isStepEmpty(e);) e--;
				this.showStep(e), this.focusFirstField(this.steps[e].element);
			}
		}, this.backButton.addEventListener("click", this.backButtonHandler));
	}
	focusFirstField(e) {
		e.querySelector([
			"input:not([type=\"hidden\"]):not([disabled])",
			"select:not([disabled])",
			"textarea:not([disabled])"
		].join(","))?.focus({ preventScroll: !0 });
	}
	isStepEmpty(e) {
		let t = this.steps[e]?.element;
		if (!t) return !1;
		let n = t.querySelectorAll(".en__field");
		return n.length > 0 && Array.from(n).every((e) => e.classList.contains("en__hidden"));
	}
	advance() {
		if (!(this.embeddedUpsell && (this.embeddedUpsell.onComplete = () => {
			this.embeddedUpsell?.destroy(), this.embeddedUpsell = null, this.advance();
		}, this.embeddedUpsell.tryShow()))) if (this.currentStep < this.steps.length - 1) {
			let e = this.currentStep + 1;
			for (; e < this.steps.length - 1 && this.isStepEmpty(e);) e++;
			this.showStep(e), this.focusFirstField(this.steps[e].element), this.scrollToForm();
		} else this.submit();
	}
	scrollToForm() {
		let e = document.querySelector(X);
		if (!e) return;
		let t = getComputedStyle(document.documentElement).getPropertyValue("--step-scroll-offset").trim(), n = parseFloat(t) || 0, r = e.getBoundingClientRect().top + window.scrollY - n;
		window.scrollTo({
			top: r,
			behavior: "smooth"
		});
	}
	showStep(e) {
		this.steps.forEach((t, n) => {
			t.element.classList.toggle("hidden", n !== e);
		}), this.backButton?.classList.toggle("hidden", e === 0), this.currentStep = e, this.updateProgressBar();
		let t = e === this.steps.length - 1;
		t ? document.body.classList.add("step-last") : document.body.classList.remove("step-last"), this.config.onStepChange?.({
			currentStep: e,
			totalSteps: this.steps.length,
			isLastStep: t,
			isFirstStep: e === 0,
			element: this.steps[e].element
		});
	}
	submit() {
		document.querySelector(X)?.requestSubmit();
	}
	checkForProcessingError() {
		new URLSearchParams(window.location.search).has("val") && this.steps.length > 0 && this.showStep(this.steps.length - 1);
	}
}, Q = class {
	constructor(e = {}) {
		document.body.classList.add("loading"), this.init(e), e.manualLoading || this.loaded();
	}
	loaded() {
		document.body.classList.remove("loading"), setTimeout(() => {
			document.body.classList.add("loaded");
		}, 300);
	}
	init(e) {
		let t = window.pageJson?.pageType, n = window.pageJson?.pageNumber, i = window.pageJson?.pageCount;
		t ? document.body.classList.add(`page-type-${t}`) : document.body.classList.add("page-type-webpage"), n === i && document.body.classList.add("last-page"), [
			"donation",
			"p2pdonation",
			"p2pcheckout",
			"premiumgift",
			"survey",
			"otherdatacapture",
			"emailsubscribeform"
		].includes(t) && a(), e.globalConfig?.requiredAsterisk && document.body.classList.add("required-asterisks"), x(), O(), j(), b(), u(), E(), I(), P(), e.hero?.enabled && new K(), e.sidebar?.enabled && new R(e.sidebar), e.validation && new Z(e.validation), e.recurringNudge && new C(e.recurringNudge), new h(e.donationAmount), e.splitGift?.enabled && new V(e.splitGift), e.giftSummary && new S(e.giftSummary), e.eCard?.picker && new s(e.eCard.picker), e.eCard?.sender?.enabled && (o.log("Initializing ECardSender from ZuriEn config", t, window.top === window.self), (window.top !== window.self || t === "ecard") && (o.log("Page is in iframe or is an ecard page, initializing ECardSender"), new c())), e.countryRegion && new r(e.countryRegion);
	}
};
requestAnimationFrame(() => document.body.classList.add("transitions-ready"));
//#endregion
export { K as Hero, R as Sidebar, V as SplitGift, Q as ZuriEn };

//# sourceMappingURL=index.js.map